import { RemoteCompany } from "../../../../data/usecases/company/remote-company";
import { Company } from "../../../../domain/models/company.model";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteCompanies = (): Company =>
  new RemoteCompany("/companies", makeAxiosHttpClient(), settings.API_URL);
